module.exports = __webpack_public_path__ + "static/media/video-05.342e3958.mp4";